import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/Home.vue'
import SimulatorView from '@/views/Simulator.vue'
import CookiePolicyView from '@/views/legal/CookiePolicy.vue'
import PrivacyPolicyView from '@/views/legal/PrivacyPolicy.vue'
import HowWeWorkView from '@/views/HowWeWork.vue'
import WhoWeAreView from '@/views/WhoWeAre.vue'

const routes = [
  { path: '/', name: 'Home', component: HomeView },
  { path: '/simulator', name: 'Simulator', component: SimulatorView },
  { path: '/legal/cookie', name: 'CookiePolicy', component: CookiePolicyView },
  { path: '/legal/privacy', name: 'PrivacyPolicy', component: PrivacyPolicyView },
{ path: '/home', redirect: '/' },
  { path: '/come-lavoriamo', name: 'HowWeWork', component: HowWeWorkView },
  { path: '/chi-siamo', name: 'WhoWeAre', component: WhoWeAreView },
  { path: '/:pathMatch(.*)*', redirect: '/' }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from) {
    if (to.hash) {
      const header = document.querySelector('.site-header')
      const top = header ? header.offsetHeight : 0
      const samePage = to.path === from.path
      return { el: to.hash, top, behavior: samePage ? 'smooth' : 'auto' }
    }
    return { top: 0 }
  }
})

export default router
